export const SET_ACCOUNT_DATA = "account/setAccountData";
export const SET_USER_DATA = "user/setUserData";
export const API_INITIALIZED = "API_INITIALIZED";
